import styled from 'styled-components'

export const ContentImg = styled.div`
  height: 126px;
  width: 126px;
  border: 2px dashed ;
  border-color: #B1C3C5;
  border-radius: 5px;
  text-align: center;
  pointer-events: none;
  display: ${(props) => props.displayN === '1' ? 'none' : 'table' };
  justify-content: center;
  align-items: center;
  margin-right: 20px;
  svg {
    height: 100%;
    width: 100%;
  }

  @media (max-width: 576px) {
    > div {
      height: ${(props) =>
              props.device ? (props.device === 'mobile' ? '206px' : '144px') : ''};

    }
  
  }

`
